module.exports = __webpack_public_path__ + "media/images/cuk-a43305495d39257f6d6564308f48fab6.png";